"use strict";

require("core-js/modules/es.array.for-each");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickRulesHelper = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// TODO: share this with EditGrid.
var EditRowState = {
  New: 'new',
  Editing: 'editing',
  Saved: 'saved',
  Removed: 'removed'
};

var QuickRulesHelper = /*#__PURE__*/function () {
  function QuickRulesHelper(editForm, options) {
    _classCallCheck(this, QuickRulesHelper);

    this.editForm = editForm;
    this.options = options;
    this.variables = this.editForm.getComponent('variables');
    this.conditions = this.editForm.getComponent('conditions');
    this.validations = this.editForm.getComponent('validations');
    this.queue = [];
  }

  _createClass(QuickRulesHelper, [{
    key: "addVariable",
    value: function addVariable(variable) {
      var _this = this;

      this.queue.push(function () {
        _this.addEditGridValue(_this.variables, variable);
      });
    }
  }, {
    key: "addCondition",
    value: function addCondition(condition) {
      var _this2 = this;

      this.queue.push(function () {
        _this2.addEditGridValue(_this2.conditions, condition);
      });
    }
  }, {
    key: "addValidation",
    value: function addValidation(validation) {
      var _this3 = this;

      this.queue.push(function () {
        _this3.addEditGridValue(_this3.validations, validation, EditRowState.New);
      });
    }
  }, {
    key: "addEditGridValue",
    value: function addEditGridValue(editGrid, value) {
      var editRowState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EditRowState.Saved;
      editGrid.dataValue.push(value);
      var index = editGrid.editRows.length;
      var editRow = {
        components: editGrid.createRowComponents(value, index),
        data: value,
        state: editRowState,
        backup: null,
        error: null
      };
      editGrid.editRows.push(editRow);
      editGrid.redraw();
      return editRow;
    }
  }, {
    key: "execute",
    value: function execute() {
      this.queue.forEach(function (handler) {
        return handler();
      });
      this.queue = [];
    }
  }]);

  return QuickRulesHelper;
}();

exports.QuickRulesHelper = QuickRulesHelper;